import * as React from 'react';
import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import styles from './NewMultiSelect.module.css';

export const NewMultiSelect: React.FC<MultiSelectProps> = ({ className, panelClassName, ...rest }) => (
  <MultiSelect
    className={[styles.multiselect, className].filter(Boolean).join(' ')}
    panelClassName={[styles.panel, panelClassName].filter(Boolean).join(' ')}
    {...rest}
  />
);
